var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#0065FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7333 9.33396H19.4333C21.2463 9.31864 22.739 10.7551 22.7933 12.5673V17.4206C22.739 19.2354 21.2422 20.6729 19.4267 20.654H18.3867C18.1276 20.6548 17.8827 20.7723 17.72 20.974L16.7333 22.2273C16.5687 22.4255 16.3243 22.5402 16.0667 22.5402C15.809 22.5402 15.5647 22.4255 15.4 22.2273L14.4067 20.974C14.244 20.7723 13.9991 20.6548 13.74 20.654H12.7333C10.9049 20.6914 9.38781 19.2486 9.33333 17.4206V12.5673C9.38781 10.7393 10.9049 9.29657 12.7333 9.33396ZM13.5667 16.3206C13.8428 16.3206 14.0667 16.0968 14.0667 15.8206V14.2206C14.0667 13.9445 13.8428 13.7206 13.5667 13.7206C13.2905 13.7206 13.0667 13.9445 13.0667 14.2206V15.8206C13.0667 16.0968 13.2905 16.3206 13.5667 16.3206ZM16.5667 15.8206C16.5667 16.0968 16.3428 16.3206 16.0667 16.3206C15.7905 16.3206 15.5667 16.0968 15.5667 15.8206V14.2206C15.5667 13.9445 15.7905 13.7206 16.0667 13.7206C16.3428 13.7206 16.5667 13.9445 16.5667 14.2206V15.8206ZM18.5667 16.3206C18.8428 16.3206 19.0667 16.0968 19.0667 15.8206V14.2206C19.0667 13.9445 18.8428 13.7206 18.5667 13.7206C18.2905 13.7206 18.0667 13.9445 18.0667 14.2206V15.8206C18.0667 16.0968 18.2905 16.3206 18.5667 16.3206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAct);
export default __webpack_public_path__ + "static/media/chatAct.c5b02d2c3ad9057360f5c0c0cc40fe93.svg";
export { ForwardRef as ReactComponent };